import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { ApiService, RestApiService, MockApiService } from '@web-nx-ng-tsc/web-shared-data-access';
import { NgxGaugeModule } from 'ngx-gauge';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(withEventReplay()),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      })
    ),
    provideAnimations(),
    provideHttpClient(),
    importProvidersFrom(NgxGaugeModule),
    {
      provide: ApiService,
      // useClass: RestApiService,
      useFactory: () => {
        if (environment.production) {
          return new RestApiService();
        } else {
          return new MockApiService();
        }
      },
    },
  ],
};
